import styled from 'react-emotion';

export const Container = styled('div')`
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const SectionViewContainer = styled('div')`
  padding-left: 101px;
  padding-right: 110px;

  @media only screen and (max-width: 1000px) {
    padding: 5%;
  }
`;

export const ContentContainer = styled('div')`
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const ScrollContainer = styled('div')`
  position: relative;
  height: 100%;
  flex: 1;
`;
